import { useEffect, useState } from "react";
import styled from "styled-components";

import { Board, PageTop, Title, TitleArea } from "components/LayoutParts";
import Loading from "components/Loading";
import { sortDirection } from "constants/direction";
import { useDebounce } from "hooks/useDebounce";
import { AIMO_PARKING_USER_ROLE, AimoParkingUserRole } from "pages/AimoParking/constants/aimoParkingUserRole";
import { useFindAllUser } from "pages/AimoParking/User/api";
import DataTable from "pages/AimoParking/User/DataTable";
import ActionArea from "pages/AimoParking/User/DataTable/ActionArea";
import { jumpUpToElement } from "utils/animationUtils";

const OverWrapTitleArea = styled(TitleArea)`
  margin-bottom: -8px;
`;

const User = () => {
  const [totalPages, setTotalPages] = useState<number>(1);
  const [currentPageIndex, setCurrentPageIndex] = useState<number>(1);
  const [sortOption, setSortOption] = useState<SortOption<SortByAimoParkingCompany>>({
    sortByColumn: "name",
    direction: sortDirection.desc,
  });
  const [searchKeyword, setSearchKeyword] = useState("");
  const [selectedFilter, setSelectedFilter] = useState<AimoParkingUserRole>(AIMO_PARKING_USER_ROLE.ALL);

  const { debouncedValue: debouncedSearchKeyword } = useDebounce(searchKeyword, 500);
  const { data, pageInfo } = useFindAllUser({
    keyword: debouncedSearchKeyword,
    pageIndex: currentPageIndex,
    orderBy: sortOption.sortByColumn,
    order: sortOption.direction,
    role: selectedFilter === AIMO_PARKING_USER_ROLE.ALL ? undefined : selectedFilter,
  });

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentPageIndex(1);
    setSearchKeyword(e.target.value);
  };

  const onFilterButtonClick = (role: AimoParkingUserRole) => {
    setCurrentPageIndex(1);
    setSelectedFilter(role);
  };

  useEffect(() => {
    setTotalPages(pageInfo?.totalPages ?? 1);
    return () => {
      jumpUpToElement("root");
    };
  }, [pageInfo?.totalPages]);

  return (
    <Board>
      <PageTop />
      <OverWrapTitleArea>
        <Title>ユーザ</Title>
      </OverWrapTitleArea>
      <ActionArea
        searchKeyword={searchKeyword}
        onSearchChange={onSearchChange}
        selectedFilter={selectedFilter}
        onFilterButtonClick={onFilterButtonClick}
      />
      {data ? (
        <DataTable
          userList={data}
          totalPages={totalPages}
          pageIndex={currentPageIndex}
          sortOption={sortOption}
          setPageIndex={setCurrentPageIndex}
          setSortOption={setSortOption}
          type="user"
        />
      ) : (
        <Loading />
      )}
    </Board>
  );
};

export default User;
